/* lt-app.js — Laser Tags v4 (urgency + side cart v2) */
(function () {
  if (window.__ltInit) return; window.__ltInit = true;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    var fmt = (window.LT && window.LT.moneyFormat) || '${{amount}}';
    var parts = (cents / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, parts.join('.'));
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  /* ---------- countdowns (to local midnight) ---------- */
  function initCountdowns() {
    var els = document.querySelectorAll('[data-lt-cd]');
    if (!els.length) return;
    function t() {
      var n = new Date(), e = new Date(n); e.setHours(23, 59, 59, 999);
      var s = Math.max(0, Math.floor((e - n) / 1000));
      var txt = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
      els.forEach(function (el) {
        if (el.hasAttribute('data-split')) {
          var p = txt.split(':'); var b = el.querySelectorAll('b');
          if (b.length === 3) { b[0].textContent = p[0]; b[1].textContent = p[1]; b[2].textContent = p[2]; }
        } else el.textContent = txt;
      });
    }
    t(); setInterval(t, 1000);
  }

  /* ---------- delivery estimate ---------- */
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
  function initDelivery() {
    document.querySelectorAll('[data-lt-eta]').forEach(function (el) {
      var a = parseInt(el.dataset.min || '6', 10), b = parseInt(el.dataset.max || '12', 10);
      var o = { month: 'short', day: 'numeric' };
      el.textContent = addBiz(new Date(), a).toLocaleDateString('en-US', o) + ' – ' + addBiz(new Date(), b).toLocaleDateString('en-US', o);
    });
  }

  /* ---------- side cart with reservation timer ---------- */
  var dr, ov, itemsEl, foot, resEl, resTimer = null, KEY = 'ltCartReserveEnd';
  function resEnd() {
    var e = 0, min = (window.LT && window.LT.reserveMin) || 5;
    try { e = +sessionStorage.getItem(KEY) || 0; } catch (_) {}
    if (!e || e < Date.now()) { e = Date.now() + min * 60000; try { sessionStorage.setItem(KEY, e); } catch (_) {} }
    return e;
  }
  function tickRes() {
    var s = Math.max(0, Math.round((resEnd() - Date.now()) / 1000));
    if (resEl) resEl.textContent = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
  }
  function setCount(n) {
    document.querySelectorAll('[data-lt-count]').forEach(function (b) { if (b.textContent != (n > 0 ? n : '')) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); } b.textContent = n > 0 ? n : ''; });
    var c = dr && dr.querySelector('[data-lt-dr-count]'); if (c) c.textContent = n;
  }
  var trash = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';
  function renderCart(c) {
    setCount(c.item_count || 0);
    if (!dr) return;
    var inCart = {};
    c.items.forEach(function (it) { inCart[String(it.variant_id)] = 1; });
    dr.querySelectorAll('[data-lt-up]').forEach(function (u) { u.style.display = inCart[u.dataset.vid] ? 'none' : ''; });
    var upw = dr.querySelector('[data-lt-up-wrap]');
    if (upw) upw.style.display = (c.items.length && [].some.call(upw.querySelectorAll('[data-lt-up]'), function (u) { return u.style.display !== 'none'; })) ? '' : 'none';
    if (!c.items.length) {
      itemsEl.innerHTML = '<div class="lt-dr-empty"><div class="lt-dr-empty-ic">🛒</div><p>Your cart is empty</p><a class="lt-btn" href="' + esc((window.LT && window.LT.shopUrl) || '/') + '">Shop now</a></div>';
      foot.style.display = 'none'; return;
    }
    foot.style.display = '';
    var cmpMap = (window.LT && window.LT.compare) || {}, save = 0, cmpTotal = 0, html = '';
    c.items.forEach(function (it, n) {
      var cmp = cmpMap[String(it.variant_id)] || 0;
      var lineCmp = cmp > it.final_price ? cmp * it.quantity : 0;
      if (lineCmp) save += lineCmp - it.final_line_price;
      cmpTotal += lineCmp || it.final_line_price;
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
      html += '<div class="lt-it" style="--i:' + n + '">' +
        '<div class="lt-it-img">' + (img ? '<img src="' + esc(img) + '" alt="" width="92" height="92">' : '') + '</div>' +
        '<div class="lt-it-b"><div class="lt-it-top"><p class="lt-it-t">' + esc(it.product_title) + '</p>' +
        '<button type="button" class="lt-it-rm" data-lt-rm="' + esc(it.key) + '" aria-label="Remove">' + trash + '</button></div>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<span class="lt-it-v">' + esc(it.variant_title) + '</span>' : '') +
        '<div class="lt-it-row"><span class="lt-q"><button type="button" data-lt-q="' + esc(it.key) + '" data-d="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-lt-q="' + esc(it.key) + '" data-d="1" aria-label="Increase">+</button></span>' +
        '<span class="lt-it-p">' + (lineCmp ? '<s>' + money(lineCmp) + '</s>' : '') + '<b>' + money(it.final_line_price) + '</b></span></div>' +
        (lineCmp ? '<span class="lt-it-save">You save ' + money(lineCmp - it.final_line_price) + '</span>' : '') +
        '</div></div>';
    });
    itemsEl.innerHTML = html;
    dr.querySelector('[data-lt-save-row]').style.display = save > 0 ? '' : 'none';
    dr.querySelector('[data-lt-save]').textContent = money(save);
    dr.querySelector('[data-lt-sub]').textContent = money(c.total_price);
    var sc = dr.querySelector('[data-lt-sub-cmp]'); if (sc) sc.textContent = cmpTotal > c.total_price ? money(cmpTotal) : '';
    var cp = dr.querySelector('[data-lt-co-price]'); if (cp) cp.textContent = money(c.total_price);
  }
  function loadCart() { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart); }
  function changeCart(key, qty) {
    return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  function openCart(added) {
    if (!dr) { window.location.href = ROOT + 'cart'; return; }
    var ad = dr.querySelector('[data-lt-added]'); if (ad) { ad.classList.remove('is-on'); if (added === true) { void ad.offsetWidth; ad.classList.add('is-on'); } }
    loadCart(); resEnd(); tickRes(); clearInterval(resTimer); resTimer = setInterval(tickRes, 1000);
    dr.classList.add('is-open'); ov.classList.add('is-open'); dr.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lt-lock');
  }
  function closeCart() {
    if (!dr) return;
    dr.classList.remove('is-open'); ov.classList.remove('is-open'); dr.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lt-lock'); clearInterval(resTimer);
  }
  window.ltOpenCart = openCart;
  function initDrawer() {
    dr = document.querySelector('[data-lt-dr]'); ov = document.querySelector('[data-lt-dr-ov]');
    if (dr) { itemsEl = dr.querySelector('[data-lt-dr-items]'); foot = dr.querySelector('[data-lt-dr-foot]'); resEl = dr.querySelector('[data-lt-res]'); }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-lt-open-cart]') && dr) { e.preventDefault(); openCart(); return; }
      var up = e.target.closest('[data-lt-up-add]');
      if (up) { up.classList.add('is-loading'); fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +up.getAttribute('data-lt-up-add'), quantity: 1 }] }) }).then(loadCart).then(function () { up.classList.remove('is-loading'); }); return; }
      if (e.target.closest('[data-lt-dr-close]') || e.target === ov) { closeCart(); return; }
      var q = e.target.closest('[data-lt-q]');
      if (q) { var sp = q.parentNode.querySelector('span'); changeCart(q.getAttribute('data-lt-q'), Math.max(0, (+sp.textContent) + (+q.getAttribute('data-d')))); return; }
      var rm = e.target.closest('[data-lt-rm]'); if (rm) changeCart(rm.getAttribute('data-lt-rm'), 0);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
    if (/[?&]cart=open/.test(location.search)) openCart();
  }

  /* ---------- reveal / gallery ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lt-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  function initGallery(g) {
    var slides = g.querySelectorAll('.lt-slide'), thumbs = g.querySelectorAll('.lt-thumb'), dots = g.querySelectorAll('.lt-dots i'), i = 0;
    if (slides.length < 2) return;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); var v = s.querySelector('video'); if (v) { k === i ? v.play().catch(function () {}) : v.pause(); } });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var p = g.querySelector('.lt-stage-nav--prev'), n = g.querySelector('.lt-stage-nav--next');
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (n) n.addEventListener('click', function () { go(i + 1); });
    var sx = null, st = g.querySelector('.lt-stage');
    st.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    st.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 35) go(dx < 0 ? i + 1 : i - 1); sx = null; });
    g.__ltGo = function (id) { slides.forEach(function (s, k) { if (s.dataset.mediaId === String(id)) go(k); }); };
  }

  /* ---------- buy box ---------- */
  function after(form) { var w = form.closest('[data-after]'); return w ? w.dataset.after : 'drawer'; }
  function addToCart(items, btn, dest) {
    if (btn) btn.classList.add('is-loading');
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        if (btn) btn.classList.remove('is-loading');
        if (dest === 'checkout') window.location.href = ROOT + 'checkout';
        else if (dest === 'cart' || !dr) window.location.href = ROOT + 'cart';
        else openCart(true);
      })
      .catch(function () { window.location.href = ROOT + 'cart/' + items.map(function (i) { return i.id + ':' + i.quantity; }).join(','); });
  }
  function formItems(form) {
    var id = form.querySelector('input[name="id"]').value;
    var q = parseInt((form.querySelector('[data-lt-qty]') || {}).value, 10) || 1;
    var items = [{ id: parseInt(id, 10), quantity: q }];
    var sel = form.querySelector('[data-lt-tier].is-selected');
    if (sel) sel.querySelectorAll('[data-lt-addon]:checked').forEach(function (c) { items.push({ id: parseInt(c.value, 10), quantity: 1 }); });
    return items;
  }
  function initBuy(form) {
    var idInput = form.querySelector('input[name="id"]'), qty = form.querySelector('[data-lt-qty]');
    var tiers = form.querySelectorAll('[data-lt-tier]'), gallery = document.querySelector('.lt-gallery');
    function refreshTotal() {
      var t = form.querySelector('[data-lt-tier].is-selected'); if (!t) return;
      var q = parseInt(t.dataset.qty, 10) || 1, price = parseInt(t.dataset.price, 10) * q, cmp = parseInt(t.dataset.compare, 10) * q;
      t.querySelectorAll('[data-lt-addon]:checked').forEach(function (c) { price += parseInt(c.dataset.price, 10) || 0; });
      document.querySelectorAll('[data-lt-btn-price]').forEach(function (el) { el.textContent = money(price); });
      document.querySelectorAll('[data-lt-btn-compare]').forEach(function (el) { el.textContent = cmp > price ? money(cmp) : ''; });
      return { price: price, cmp: cmp };
    }
    function select(t) {
      tiers.forEach(function (x) { x.classList.toggle('is-selected', x === t); });
      var r = t.querySelector('input[type="radio"]'); if (r) r.checked = true;
      idInput.value = t.dataset.variantId;
      var q = parseInt(t.dataset.qty, 10) || 1; if (qty) qty.value = q;
      var price = parseInt(t.dataset.price, 10) * q, cmp = parseInt(t.dataset.compare, 10) * q;
      refreshTotal();
      document.querySelectorAll('[data-lt-sticky-name]').forEach(function (el) { el.textContent = t.dataset.name; });
      document.querySelectorAll('[data-lt-sticky-price]').forEach(function (el) { el.textContent = money(price); });
      document.querySelectorAll('[data-lt-sticky-compare]').forEach(function (el) { el.textContent = cmp > price ? money(cmp) : ''; });
      if (t.dataset.mediaId && gallery && gallery.__ltGo) gallery.__ltGo(t.dataset.mediaId);
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function (e) { if (e.target.closest('.lt-bx-addon')) return; e.preventDefault(); select(t); });
    });
    form.addEventListener('change', function (e) { if (e.target.matches('[data-lt-addon]')) refreshTotal(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(formItems(form), form.querySelector('[data-lt-submit]'), after(form)); });
    var s = (location.search.indexOf('variant=') === -1 && form.querySelector('[data-lt-tier][data-popular="true"]')) || form.querySelector('[data-lt-tier].is-selected') || tiers[0];
    if (s) select(s);
  }
  function initSticky() {
    var s = document.querySelector('.lt-sticky'), anchor = document.querySelector('[data-lt-buy-anchor]');
    if (s && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { var e = en[0]; s.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(anchor);
    }
    document.querySelectorAll('[data-lt-buy-now]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var form = document.querySelector('form.lt-form');
        if (b.dataset.ltBuyNow === 'scroll' || !form) { var t = document.getElementById('lt-buy'); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); } return; }
        e.preventDefault(); addToCart(formItems(form), b, after(form));
      });
    });
  }
  function initFaq() {
    document.querySelectorAll('[data-lt-faq]').forEach(function (list) {
      var ds = list.querySelectorAll('details');
      ds.forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) ds.forEach(function (o) { if (o !== d) o.open = false; }); }); });
    });
  }

  function boot() {
    initDrawer(); initCountdowns(); initDelivery(); initReveal(); initFaq();
    document.querySelectorAll('.lt-gallery').forEach(initGallery);
    document.querySelectorAll('form.lt-form').forEach(initBuy);
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('.lt-reveal').forEach(function (x) { x.classList.add('is-in'); }); });
})();
